<p-toast></p-toast>

<div #rendererContainerObj id="rendererContainerObj" style="width:100%;height: 100%;"></div>
 <svg id="svgobj"
  width="200"
  height="200"
  viewBox="-100 -100 200 200"
>


